module.exports = __webpack_public_path__ + "static/media/data_red.05327f51.svg";